export default __webpack_public_path__ + "static/media/Nuorelle_siivet_logo.1b973afc.png";